<template>
  <div>
    <div id="imgDiv" v-show="false"></div>
    <div data-v-2113713f="" data-v-6f13ff2a="" class="page-col2">
      <div
        data-v-389d87ef=""
        data-v-2620c8cd=""
        data-v-2113713f=""
        class="card-wrap page"
        data-v-6f13ff2a=""
      >
        <div data-v-389d87ef="" class="card-wrap-header">
          <div data-v-389d87ef="" class="title">
            <div data-v-389d87ef="" class="flex">
              <div data-v-389d87ef="" class="unicon"></div>
               <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'schema'"
                style="cursor: pointer"
              >
                结构颗粒数据结构 </span
              ><!---->
               <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'pic'"
                style="cursor: pointer"
              >
                图表颗粒数据结构 </span
              ><!---->
              <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'person'"
                style="cursor: pointer"
              >
                人物颗粒数据结构 </span
              ><!---->
              <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'org'"
                style="cursor: pointer"
              >
                机构颗粒数据结构 </span
              ><!---->
               <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'event'"
                style="cursor: pointer"
              >
                事件颗粒数据结构 </span
              ><!---->
               <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'geo'"
                style="cursor: pointer"
              >
                地理颗粒数据结构 </span
              ><!---->
              <span
                data-v-389d87ef=""
                class="card-wrap-title"
                v-if="schemaType === 'work'"
                style="cursor: pointer"
              >
                作品颗粒数据结构 </span
              ><!---->
            </div>
          </div>
        </div>
        <div data-v-389d87ef="" class="card-wrap-content">
          <div data-v-2620c8cd="" data-v-389d87ef="" class="struct">
            <div
              data-v-a36ddf66=""
              data-v-2620c8cd=""
              class="description"
              data-v-389d87ef=""
            >
              <div data-v-a36ddf66="" class="description-header">
                <div data-v-a36ddf66="" class="title">
                  {{bookDetail.title}}
                </div>
              </div>
              <div data-v-a36ddf66="" class="description-body">

                <div data-v-2620c8cd="" data-v-a36ddf66="" class="mult">
                  <div
                    data-v-53ea770e=""
                    data-v-2620c8cd=""
                    class="description-item"
                    data-v-a36ddf66=""
                    v-for="(value,key) in bookDetail.paramLst" :key="key"
                    v-if="value!==''&& value!==null"
                  >
                    <div data-v-53ea770e="" class="description-item-label">
                      <div data-v-2b0a0a7c="" data-v-53ea770e="" class="ctext">
                        <div
                          data-v-2b0a0a7c=""
                          class="ctext-dot"
                          style="width: 5px; height: 5px"
                        ></div>
                        <div data-v-2b0a0a7c="" class="ctext-content">
                          {{key}}
                        </div>
                      </div>
                    </div>
                    <div data-v-53ea770e="" class="description-item-value">
                      <div data-v-2b0a0a7c="" data-v-53ea770e="" class="ctext">
                        <!---->
                        <div data-v-2b0a0a7c="" class="ctext-content">
                         {{value}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                        data-v-6edc5341=""
                        type="button"
                        style="width: 200px"
                        class="el-button el-button--danger"
                        @click="goToPage(bookDetail.page)"
                      >
                        <!----><i class="lib-icon-book"></i
                        ><span> &nbsp;&nbsp;立即阅读 </span>
                      </button>
              </div>
            </div>
            <!---->
            <div
              data-v-a36ddf66=""
              data-v-2620c8cd=""
              class="description mt"
              v-if="bookDetail.description.trim()!==''&&bookDetail.description!==null"
              data-v-389d87ef=""
            >
              <div data-v-a36ddf66="" class="description-header" >
                <div data-v-a36ddf66="" class="title"  v-if="schemaType === 'schema'">摘要</div>
                <div data-v-a36ddf66="" class="title"  v-if="schemaType === 'pic'">内容</div>
                <div data-v-a36ddf66="" class="title"  v-if="schemaType === 'person'">生平</div>
                <div data-v-a36ddf66="" class="title"  v-if="schemaType === 'org'||schemaType === 'event'||schemaType === 'geo'">描述</div>

                <div data-v-a36ddf66="" class="border"></div>
              </div>
              <div data-v-a36ddf66="" class="description-body">
                <div
                  data-v-2b0a0a7c=""
                  data-v-2620c8cd=""
                  class="ctext txt"
                  data-v-a36ddf66=""
                >
                  <!---->
                  <div data-v-2b0a0a7c="" class="ctext-content">
                    <span
                      data-v-2620c8cd=""
                      data-v-2b0a0a7c=""
                      class="biography-text"
                      >{{bookDetail.description}}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <div
              data-v-a36ddf66=""
              data-v-4195913d=""
              data-v-2620c8cd=""
              class="description c-reader mt"
              v-if="bookDetail.page!==null && bookDetail.page!==''"
            >
              <div data-v-a36ddf66="" class="description-body">
              </div>
               <el-tabs v-model="activeName">
                    <el-tab-pane name="first">
                      <span slot="label"  style="font-size: 16px; font-weight: 700; color: #595959;">图片预览</span>
                  <div data-v-4195913d="" data-v-a36ddf66="" class="c-reader-content mt">
                <div data-v-4195913d="" class="el-carousel el-carousel--horizontal" data-v-a36ddf66="">
                  <div class="el-carousel__container" style="height: 1182.18px;">

                      <div data-v-4195913d="" class="el-carousel__item is-active is-animating" style="transform: translateX(0px) scale(1);"><!---->
                        <div data-v-4195913d="">
                          <img data-v-4195913d="" :src=reviewAddr width="auto"></div>
                        </div>

                              </div>
                              </div><!---->
                              </div>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                       <span slot="label"  style="font-size: 16px; font-weight: 700; color: #595959;">原文阅读</span>
                       <div data-v-2b0a0a7c="" class="ctext-content">
                           <pre  style="font-size: 16px; line-height: 30px;  font-weight: 600;">{{bookDetail.content}}</pre>
                        </div>
                    </el-tab-pane>
              </el-tabs>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bookApi from '@/api/book';

export default {
  data () {
    return {
      records: [],
      bookDetail: {},
      schemaType: {},
      pageIndex: 1,
      pageSize: 1,
      total: 0,
      searchValue: '',
      reviewAddr: '',
      activeName: 'first'
    };
  },
  mounted () {},
  methods: {
    getDataDetail (identifier, bookType, schemaType) {
      this.records = [];
      let that = this;
      this.schemaType = schemaType;
      bookApi
        .getBook({
          path: 'getBookDataWithPrs',
          pageindex: this.pageindex,
          pageSize: this.pageSize,
          bookType: bookType,
          schemaType: schemaType,
          identifier: identifier,
          libraryCode: this.global.getLibraryInfos().code
        })
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.bookDetail = response.data.rows[0];
            that.transPdfToImage(that.bookDetail.pagePic);
            console.log(that.bookDetail);
          }
        });
    },
    goToPage (startFileName) {
      if (startFileName) {
      if (startFileName.lastIndexOf('.') > 0) {
        startFileName = startFileName.substring(0, startFileName.lastIndexOf('.')).toUpperCase()
      } else {
        startFileName = startFileName.toUpperCase()
      }
      }

      let routeData = this.$router.resolve({
        path: '/bookView',
        query: {
          bookId: this.bookDetail.sourceID,
          bookType: 'book',
          startPage: startFileName
        }
      });

      // 必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    transPdfToImage (pdfUrl) {
       let that = this;
			$('#imgDiv').empty();
			// function fileToDataURL (file) {
			// 	let reader = new FileReader()
			// 	reader.readAsDataURL(file)
			// 	// reader 读取文件成功的回调
			// 	reader.onload = function (e) {
			// 	return reader.result
			// 	}
			// }
			// function blobToFile (value, filename = 'file') {
			// return new window.File([value], filename, { type: value.type });
			// }

			function output () {
				var height = 0; var context; var mainCanvas; var b = 2; // b：整图缩放倍数
				var count = $('canvas').length;
				$('canvas').each(function (index, ele) {
					var canvas = document.getElementById('pdfCanvas');
					if (canvas) {
						if (index === 0) {
							mainCanvas = document.createElement('canvas');
							context = mainCanvas.getContext('2d');
							mainCanvas.width = canvas.width / b;
							mainCanvas.height = canvas.height / b * count;
							context.drawImage(canvas, 0, 0, canvas.width / b, canvas.height / b);
						} else {
							context.drawImage(canvas, 0, height, canvas.width / b, canvas.height / b);
						}
						height += canvas.height / b;
					}
				})
				if (mainCanvas) {
					// let img = dataURLtoBlob(mainCanvas.toDataURL('image/png', 1.0));
					that.reviewAddr = mainCanvas.toDataURL('image/png', 0.1).replace(/[\r\n]/g, '');
					// eslint-disable-next-line no-new
					// new Compressor(dataURLtoBlob(img), {
					// 	quality: 0,
					// 	success (result) {
					// 		console.log(result) // 处理后的文件流BLOB
					// 		let reader = new FileReader()
					// 		reader.readAsDataURL(result)
					// 		// reader 读取文件成功的回调
					// 		reader.onload = function (e) {
					// 			console.log('压缩后', reader.result);
					// 			that.pages.push(reader.result);
					// 			that.addPage(that.currentPage + 1);
					// 			$('#imgDiv').empty();
					// 			return reader.result
					// 		}
					// 	},
					// 	error (err) {
					// 	// 错误处理
					// 		console.log(err.message)
					// 	}
					// })
					$('#imgDiv').empty();
					// that.bookShow = true;
				}
			}
			function openPage (pdfFile, pageNumber, context) {
				var scale = 2;
				pdfFile.getPage(pageNumber).then(page => {
					let viewport = page.getViewport(scale); // reference canvas via context
					var canvas = context.canvas;
					canvas.width = viewport.width;
					canvas.height = viewport.height;
					// 记录当前canvas的width，height
					window.wi = canvas.width;
					window.he = canvas.height;
					canvas.style.width = '100%';
					canvas.style.height = '100%';
					var renderContext = {
						canvasContext: context,
						viewport: viewport
					};
					page.render(renderContext).then(e => {
						output();
					});
				});
			};

			PDFJS.getDocument(pdfUrl).then(pdf => {
				$('#imgDiv').css('border', '0'); // 清除文本、边框
				if (pdf) {
					window.pageNum = pdf.numPages;
					// $('#pagesText').text(pageNum);
					var canvas = document.createElement('canvas');
					canvas.id = 'pdfCanvas';
					$('#imgDiv').append(canvas);
					var context = canvas.getContext('2d');
					openPage(pdf, 1, context);
				}
			});
		}
  }
};
</script>

<style src="./app.841a88aa.css"  scoped></style>
<style lang="less" scoped>
 /deep/.el-tabs__active-bar{
  background-color:#8d5e1a
 }
</style>
